import { InputImagePreview } from "components/InputImage/InputImagePreview";
import { InputImageUpdate } from "components/InputImage/InputImageUpdate";

export function ImageListInput({ value, disabled, onChange }: { value: any, disabled: boolean, onChange: (data: any) => void }) {
    const images = Array.isArray(value) ? value : [];

    return (
        <div>
            <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                Multi Shot Angle
            </label>
            <div className="grid grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-6">
                {images.map((image) => (
                    <InputImagePreview
                        key={image}
                        value={image}
                        onDelete={() => {
                            const newData: string[] = images.filter((i) => i !== image);
                            onChange(newData);
                        }}
                        disabled={disabled}
                    />
                ))}
                {images.length < 5 && (
                    <InputImageUpdate
                        onChange={(image) => {
                            const newData: string[] = [...images, image];
                            onChange(newData);
                        }}
                        disabled={disabled}
                    />
                )}
            </div>
        </div>
    );
}
